import { OrderEventStatus } from "../dto/order-event-status.enum";

	/**
	 * @description
	 *  Modelo de una nota de CyR controlada.
	 *
	 * @see gigot-backend/ViewModels/OrderEvent/OrderEventForProductsPlane.cs
	 */

export class OrderEventForProductsPlane {

	public campaignNumber: string;
	public code: string;
	public generateCreditNote: boolean;
	public id: number;
	public name: string;
	public orderEventStatus: OrderEventStatus;
	public price: number;
	public quantity: number;
	public userFullName: string;
	public userNumber: string;
	public zone: number;

	/**
	 * @description
	 *	Construye una nota controlada con una semántica vacía. Nótese que no
	 *	es lo mismo que construir una nota con valores por defecto. Las reglas
	 *  generales de construcción son:
	 *
	 *      - Campos 'array' se definen como [].
	 *      - Campos 'boolean' se definen como 'false'.
	 *      - Campos 'Date' se definen como 'undefined'.
	 *      - Campos 'enum' se definen como 'undefined'.
	 *      - Campos 'number' se definen como 'undefined'.
	 *      - Campos 'string' se definen como '' (cadena vacía).
	 *      - Campos 'object' se definen llamando a su propio método #empty().
	 *      - Campos de la superclase se definen al igual que campos 'object'.
	 *      - Campos genéricos se definen como 'undefined'.
	 *		- Campos recursivos se definen como 'undefined'.
	 *
	 * @returns
	 *	Una nota controlada vacía.
	 */
	public static empty(): OrderEventForProductsPlane {
		const orderEventForProductsPlane: OrderEventForProductsPlane = new OrderEventForProductsPlane();
		orderEventForProductsPlane.campaignNumber = "";
		orderEventForProductsPlane.code = "";
		orderEventForProductsPlane.generateCreditNote = false;
		orderEventForProductsPlane.id = undefined;
		orderEventForProductsPlane.name = "";
		orderEventForProductsPlane.orderEventStatus = undefined;
		orderEventForProductsPlane.price = undefined;
		orderEventForProductsPlane.quantity = undefined;
		orderEventForProductsPlane.userFullName = "";
		orderEventForProductsPlane.userNumber = "";
		orderEventForProductsPlane.zone = undefined;
		return orderEventForProductsPlane;
	}

	/**
	 * @description
	 *  Método de reificación de un modelo compatible anémico. Esto permite
	 *  ejecutar lógica de negocios sobre el modelo generado, siendo que el
	 *  valor de sus propiedades se mantiene.
	 *
	 * @param anemicOrderEventForProductsPlane
	 *  El modelo anémico a reificar.
	 *
	 * @returns
	 *  Devuelve un modelo de esta clase, cuyas propiedades fueron copiadas en
	 *  profundidad desde el modelo anémico.
	 */
	public static from(anemicOrderEventForProductsPlane: OrderEventForProductsPlane): OrderEventForProductsPlane {
		if (!anemicOrderEventForProductsPlane) return undefined;
		const orderEventForProductsPlane: OrderEventForProductsPlane = OrderEventForProductsPlane.empty();
		orderEventForProductsPlane.campaignNumber = anemicOrderEventForProductsPlane.campaignNumber;
		orderEventForProductsPlane.code = anemicOrderEventForProductsPlane.code;
		orderEventForProductsPlane.generateCreditNote = anemicOrderEventForProductsPlane.generateCreditNote;
		orderEventForProductsPlane.id = anemicOrderEventForProductsPlane.id;
		orderEventForProductsPlane.name = anemicOrderEventForProductsPlane.name;
		orderEventForProductsPlane.orderEventStatus = anemicOrderEventForProductsPlane.orderEventStatus;
		orderEventForProductsPlane.price = anemicOrderEventForProductsPlane.price;
		orderEventForProductsPlane.quantity = anemicOrderEventForProductsPlane.quantity;
		orderEventForProductsPlane.userFullName = anemicOrderEventForProductsPlane.userFullName;
		orderEventForProductsPlane.userNumber = anemicOrderEventForProductsPlane.userNumber;
		orderEventForProductsPlane.zone = anemicOrderEventForProductsPlane.zone;
		return orderEventForProductsPlane;
	}
}
